import React from 'react';

export default function MapboxCluster({ comps = [] }) {
  return (
    <div style={{ height: 320, background: '#aac', padding: 16 }}>
      Cluster-ready placeholder ({comps.length} points)
    </div>
  );
}
